import type { SubFamily } from '../../types/isomorphic/subscriptionClassification';

/**
 * Maps RF subscription subFamily values to their corresponding
 * translation keys for display labels.
 */
export const RF_SUBFAMILY_LABEL_KEYS: Record<SubFamily, string> = {
  creative: 'creative_image_subscription',
  editorial: 'editorial_image_subscription',
};

export const RF_SUBFAMILY_TITLE_KEYS: Record<SubFamily, string> = {
  creative: 'creative_image_subscription_caps',
  editorial: 'editorial_image_subscription_caps',
};

export const DEFAULT_RF_LABEL_KEY = 'subscription';

export const getRfSubscriptionLabelKey = (subFamily?: string): string =>
  (subFamily ? RF_SUBFAMILY_LABEL_KEYS[subFamily as SubFamily] : undefined) ??
  DEFAULT_RF_LABEL_KEY;

export const getRfSubscriptionTitleKey = (subFamily?: string): string =>
  (subFamily ? RF_SUBFAMILY_TITLE_KEYS[subFamily as SubFamily] : undefined) ??
  DEFAULT_RF_LABEL_KEY;
